module.exports = __webpack_public_path__ + "img/21.bc5ffd04.jpg";